import { defineComponent as _defineComponent } from 'vue'
import { watch, onMounted, computed } from 'vue';
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'AmountBox',
  props: {
  custom_amount: Boolean,
  title: String,
  symbol: String,
  symbols: Object,
  strings: Object,
  display_amount: Number,
  min_donation_amount: Number,
  max_donation_amount: Number,
  show_min_max_donation: Boolean,
  post_type: String
},
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return props.symbols?.[store.currency] ?? props.symbol;
};



// Currency conversion function
const convertAmount = (amount: number) => {
  if (!amount || !lifeline_donation?.exchange_rates) {
    return amount;
  }
  
  const currentCurrency = store.currency;
  const exchangeRate = _.get(lifeline_donation.exchange_rates, currentCurrency);
  
  if (exchangeRate) {
    return (amount * exchangeRate).toFixed(2);
  }
  
  return amount;
};

const isNumber = (evt: KeyboardEvent) => {
  const charCode = evt.which || evt.keyCode;
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    evt.preventDefault();
  }
};

const updateAmount = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.value) {
    store.amount = parseFloat(target.value);
  } else {
    store.amount = null; // Ensure the amount is null if the input is empty
  }
};

onMounted(() => {
  if (props.display_amount && !props.custom_amount) {
    // For product donations, set the amount to the display amount
    store.amount = props.display_amount;
  } else {
    // For regular donations, start with null
    store.amount = null;
  }
});

// Watch for currency changes to update the display amount
watch(() => store.currency, (newCurrency) => {
  if (props.display_amount && !props.custom_amount) {
    // Update the store amount with the converted value when currency changes
    const convertedAmount = convertAmount(props.display_amount);
    store.amount = typeof convertedAmount === 'string' ? parseFloat(convertedAmount) : convertedAmount;
  }
});

// watch(() => store.amount, (val) => {
//   if (props.show_min_max_donation) {
//     if (['cause', 'wp_commerce_forms'].includes(props.post_type)) {
//       if (val > props.max_donation_amount) {
//         store.amount = props.max_donation_amount;
//         ElNotification({
//           title: 'Error',
//           message: `Amount should be less than ${props.max_donation_amount}`,
//           type: 'error',
//           duration: 5000,
//           showClose: true
//         });
//       }
//       if (val < props.min_donation_amount) {
//         store.amount = props.min_donation_amount;
//         ElNotification({
//           title: 'Error',
//           message: `Amount should be greater than ${props.min_donation_amount}`,
//           type: 'error',
//           duration: 5000,
//           showClose: true
//         });
//       }
//     }
//   }
// });

const __returned__ = { store, props, lifeline_donation, _, getSymbol, convertAmount, isNumber, updateAmount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})